import React from "react";
import * as PropTypes from "prop-types";
import { Box } from "@chakra-ui/core";
import CategoryTag from "./categoryTag";
import CategoryType from "./categoryType";
import { useIntl } from "gatsby-plugin-intl";
import DeliveryTag from "./deliveryTag";

const CategoryList = ({ categories, listing, delivery, ...rest }) => {
  const intl = useIntl();
  if (categories || delivery) {
    return (
      <Box {...rest}>
        {!!delivery && (
          <DeliveryTag listing={listing} intl={intl} />
        )}
        {categories.map((item, index) => (
          <CategoryTag
            key={item.id}
            category={item}
            index={index}
            listing={listing}
            locale={intl.locale}
          />
        ))}
      </Box>
    );
  }
  return null;
};

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(CategoryType),
  listing: PropTypes.bool,
  delivery: PropTypes.bool,
};

CategoryList.defaultProps = {
  categories: null,
  listing: false,
  delivery: false,
};

export default CategoryList;
